import useUpperAndLowerContext from './hooks/useUpperAndLowerContext';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import React, { useEffect, useRef } from 'react';
import { archRententionOption, upperAndLowerQuestionsFieldName } from '../Question';
import { ExpandMore } from '@material-ui/icons';
import RadioRhf from '../components/RadioRhf/RadioRhf';
import { RadioOptionRhf } from '../components/RadioRhf/RadioOptionRhf';
import TeethEquipmentRhf from './Question/TeethEquipmentRhf';
import ClearRetainerRhf from './Question/ClearRetainerRhf';
import useResetRhfFields from './hooks/useResetField';
import useDiffRetainerLangContext from './hooks/useDiffRetainerLangContext';
import usePonticOption from './hooks/usePonticOption';
import RetainerTypeFormControlLabelRhf from './RetainerTypeFormControlLabelRhf';
import useFormQuestionEnable from './hooks/useFormQuestionEnable';
import useResetSubOption from './hooks/useResetSubOption';
import { SelectRhf } from '../components/selectRhf/SelectRhf';
import useSetTriggerValue from './hooks/useSetTriggerValue';
import { useLang } from '../../../util/lang';
import { IMPRESSION_TYPE } from '../../../pages/hooks/DiffRetainerHooks/useRetainerRequestForm';
import { useDispatch } from 'react-redux';
import { RESET_SINGLE_TOOTH_SELECTIONS } from '../../../store/DiffRetainers/actionType';
import { isRetainerEcodontOrClearRetainer } from '../../../pages/DiffRetainer/utils';
import useRetainerCommon from './hooks/useRetainerCommon';

const SingleTypePrescriptionNote = ({
    toothForBiteRamp,
    setToothForBiteRamp,
    toothForPontics,
    setToothForPontics,
    type = 'Upper',
    questions,
    isTab = false,
}) => {
    const { uiContext, formContext } = useUpperAndLowerContext();
    const { handleExpand, expanded, impressionType } = uiContext;
    const { control, errors, formValues, dirtyFields, resetField, setValue, trigger } = formContext;
    const fieldName = type === 'Upper' ? upperAndLowerQuestionsFieldName.UPPER : upperAndLowerQuestionsFieldName.LOWER;
    const { getDiffRetainerLang } = useDiffRetainerLangContext();
    const getGlobalLang = useLang('global');
    const dispatch = useDispatch();

    const { memoPonticOption } = usePonticOption({ selectedRetainerType: formValues[`${type}ArchAndQuantity`] });
    const { retainerDesignQuestion } = useRetainerCommon({
        selectedRetainer: formValues[`${type}ArchAndQuantity`],
        impressionType,
        subType: type,
        getDiffRetainerLang,
        option: {
            fixedWire: formValues[`${type}FixedWire`],
            clearRetainerDesignUpperOption: formValues[`${type}ClearRetainerDesignUpperOption`],
            clearRetainerDesignLowerOption: formValues[`${type}ClearRetainerDesignLowerOption`],
            archAndQuantity: formValues[`${type}ArchAndQuantity`],
        },
    });

    const {
        enableOccBiteRampQuestion, // Q4
        enableClearRetainerDesignQuestion, // Q5
        // enableClearRetainerDesignQuestionForSecondSetRetainer , // Q6
        enablePontic,
    } = useFormQuestionEnable({ formValues, impressionType, subType: type });

    useResetSubOption({
        resetField,
        subOption: [
            `${type}BleachingRetainersSelect`,
            `${type}PalatalWireSelect`,
            `${type}SmartFitWireSelect`,
            `${type}EcodontWireSelect`,
            `${type}EcodontRetainerWithWire_1setSelect`,
            `${type}LowTrimlineAreaSelect_3`,
            `${type}LowTrimlineAreaSelect_1`,
            `${type}JigPlacementSelect`,

            `${type}Pontic`,
            `${type}PonticColor`,
        ],
        trackValue: formValues[`${type}ArchAndQuantity`],
    });

    useResetRhfFields(
        formValues[`${type}FixedWire`],
        formValues[`${type}FixedWire`] === 'true' || formValues[`${type}FixedWire`] === 'false',
        [
            `${type}ArchAndQuantity`,
            `${type}BleachingRetainersSelect`,
            `${type}PalatalWireSelect`,
            `${type}SmartFitWireSelect`,
            `${type}EcodontWireSelect`,
            `${type}EcodontRetainerWithWire_1setSelect`,
            `${type}LowTrimlineAreaSelect_3`,
            `${type}LowTrimlineAreaSelect_1`,
            `${type}JigPlacementSelect`,

            `${type}ClearRetainerDesignUpper`,
            `${type}ClearRetainerDesignUpperOption`,
            `${type}ClearRetainerDesignLower`,
            `${type}ClearRetainerDesignLowerOption`,

            `${type}Pontic`,
            `${type}Pontics`,
            `${type}PonticColor`,
            `${type}OcclusalBiteRampQuestion`,
        ],
        resetField
    );

    useResetRhfFields(
        formValues[`${type}ArchAndQuantity`],
        !enableOccBiteRampQuestion,
        [`${type}OcclusalBiteRampQuestion`],
        resetField
    );

    useResetRhfFields(
        formValues[`${type}ArchAndQuantity`],
        !enableClearRetainerDesignQuestion,
        [
            // `${type}ClearRetainerDesignUpper`,
            `${type}ClearRetainerDesignUpperOption`,
            // `${type}ClearRetainerDesignLower`,
            `${type}ClearRetainerDesignLowerOption`,
        ],
        resetField
    );
    useResetRhfFields(
        formValues[`${type}ArchAndQuantity`],
        [
            // `${type}ClearRetainerDesignUpper`,
            `${type}ClearRetainerDesignUpperOption`,
            // `${type}ClearRetainerDesignLower`,
            `${type}ClearRetainerDesignLowerOption`,
        ],
        resetField
    );
    useResetRhfFields(
        formValues[`${type}Pontic`],
        formValues[`${type}Pontic`] !== 'colourPonticRequired',
        [`${type}PonticColor`],
        resetField
    );

    // this ref and effect for setting default value and reset value when retainer type is changed for new case
    // const prevFormValuesRef = useRef()

    // useEffect(() => {
    //     const prevFormValues = prevFormValuesRef.current;
    //     if(prevFormValuesRef.current && impressionType === IMPRESSION_TYPE.UPPER_AND_LOWER) {

    //         if(prevFormValuesRef.current[`UpperArchAndQuantity`] !== formValues[`UpperArchAndQuantity`]) {
    //             if(type === 'Upper') {
    //                 if(formValues[`UpperFixedWire`] === 'true' && prevFormValues['UpperClearRetainerDesignUpperOption'] !== 'NotCoverLingualOrPalatalWire') {
    //                     setValue(`UpperClearRetainerDesignUpperOption`, 'NotCoverLingualOrPalatalWire')
    //                     if(isRetainerEcodontOrClearRetainer(formValues[`UpperArchAndQuantity`]))  {
    //                         setValue(`UpperClearRetainerDesignUpperOptionForSecondSet`, 'NotCoverLingualOrPalatalWire')
    //                     } else setValue(`UpperClearRetainerDesignUpperOptionForSecondSet`, undefined)
    //                 }
    //             }
    //         }

    //         if(prevFormValuesRef.current[`LowerArchAndQuantity`] !== formValues[`LowerArchAndQuantity`]) {
    //             if(type === 'Lower') {
    //                 if(formValues[`LowerFixedWire`] === 'true' && prevFormValues['LowerClearRetainerDesignLowerOption'] !== 'NotCoverLingualOrPalatalWire') {
    //                     setValue(`LowerClearRetainerDesignLowerOption`, 'NotCoverLingualOrPalatalWire')
    //                     if(isRetainerEcodontOrClearRetainer(formValues[`LowerArchAndQuantity`]))  {
    //                         setValue(`LowerClearRetainerDesignLowerOptionForSecondSet`, 'NotCoverLingualOrPalatalWire')
    //                     } else setValue(`LowerClearRetainerDesignLowerOptionForSecondSet`, undefined)
    //                 }
    //             }
    //         }
    //     }

    //     prevFormValuesRef.current = formValues;
    // },[formValues , setValue , type , impressionType])

    // useSetTriggerValue({
    //     formMethods: {setValue, trigger},
    //     condition : isRetainerEcodontOrClearRetainer(formValues[`${type}ArchAndQuantity`]) && formValues[`${type}FixedWire`] === 'true' && formValues[`${type}ClearRetainerDesignUpperOption`],
    //     fields : [`${type}ClearRetainerDesignUpperOptionForSecondSet`],
    //     value : formValues[`${type}ClearRetainerDesignUpperOption`],
    //     isReset : true
    // })

    // useSetTriggerValue({
    //     formMethods: {setValue, trigger},
    //     condition : isRetainerEcodontOrClearRetainer(formValues[`${type}ArchAndQuantity`]) && formValues[`${type}FixedWire`] === 'true' && formValues[`${type}ClearRetainerDesignLowerOption`],
    //     fields : [`${type}ClearRetainerDesignLowerOptionForSecondSet`],
    //     value : formValues[`${type}ClearRetainerDesignLowerOption`],
    //     isReset : true
    // })

    useSetTriggerValue({
        formMethods: { setValue, trigger },
        condition: formValues[`${type}Pontic`] === 'noPonticColour',
        fields: [`${type}PonticColor`],
        value: null,
        isReset: true,
    });

    return (
        <Accordion expanded={true} onChange={handleExpand(type)} disabled={!impressionType}>
            <AccordionSummary
                // expandIcon={<ExpandMore/>}
                aria-controls="single-type-content"
                id="single-type-headrer"
                style={{ height: 25 }}
            >
                <h4>{getDiffRetainerLang(`formOptions.${type}`)}</h4>
                {/* {type => Upper / Lower} */}
            </AccordionSummary>
            <AccordionDetails>
                <section style={{ width: '100%' }}>
                    <ol start={2}>
                        <li>
                            <RadioRhf
                                question={getDiffRetainerLang(`formQuestionLabel.${questions[2]?.name}`)}
                                errors={errors}
                                name={fieldName[2]}
                                control={control}
                                defaultValue={questions[2]?.defaultValue || 'false'}
                                formControlLabelRhf={questions[2].option.map((v) => (
                                    <RadioOptionRhf value={v.value} label={getGlobalLang(`const.${v.label}`)} />
                                ))}
                            />
                        </li>

                        <li>
                            <RadioRhf
                                question={getDiffRetainerLang(`formQuestionLabel.${questions[3].name}`)}
                                errors={errors}
                                name={fieldName[3]}
                                control={control}
                                row={false}
                                formControlLabelRhf={
                                    <>
                                        <RetainerTypeFormControlLabelRhf
                                            question={questions}
                                            selectedRetainer={formValues[`${type}ArchAndQuantity`]}
                                            fixedWire={formValues[`${type}FixedWire`]}
                                            control={control}
                                            errors={errors}
                                            subType={type}
                                        />
                                    </>
                                }
                            />
                        </li>

                        {enableOccBiteRampQuestion && (
                            <li>
                                <div style={{ marginTop: 24 }}>
                                    <div style={{ color: enableOccBiteRampQuestion ? 'black' : 'gray' }}>
                                        <TeethEquipmentRhf
                                            option={questions[4].option}
                                            question={getDiffRetainerLang(`formQuestionLabel.${questions[4].name}`)}
                                            name={fieldName[4]}
                                            control={control}
                                            errors={errors}
                                            defaultValue={undefined}
                                            row={false}
                                            disable={!enableOccBiteRampQuestion}
                                            teethSelectionDisabled={
                                                formValues[`${type}OcclusalBiteRampQuestion`] === 'false' ||
                                                formValues[`${type}OcclusalBiteRampQuestion`] === undefined
                                            }
                                            selectedTooth={toothForBiteRamp}
                                            setSelectedTooth={setToothForBiteRamp}
                                            showTeethSelection={
                                                formValues[`${type}OcclusalBiteRampQuestion`] === 'true'
                                            }
                                            isTab={isTab}
                                            impressionType={impressionType}
                                            subType={type}
                                            currentEditingType={expanded}
                                            radioOnChange={(e) => {
                                                if (e.target.value === 'false') {
                                                    setToothForBiteRamp([]);
                                                    dispatch({ type: RESET_SINGLE_TOOTH_SELECTIONS, payload: type });
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            </li>
                        )}

                        {(enableClearRetainerDesignQuestion )  && (
                            <li>
                                <div style={{ marginTop: 24 }}>
                                    <div style={{ color: (enableClearRetainerDesignQuestion ) ? 'black' : 'gray' }}>
                                        <ClearRetainerRhf
                                            questionData={{
                                                A: {
                                                    question: '5. Clear Retainer Design Question U/L U&L',
                                                    name: 'UpperClearRetainerDesignUpper',
                                                    label: 'Upper Arch Retention',
                                                    value: false,
                                                    children: {
                                                        component: 'RadioRhf',
                                                        name: 'UpperClearRetainerDesignUpperOption',
                                                        option: archRententionOption,
                                                    },
                                                },
                                                B: {
                                                    question: '5. Clear Retainer Design Question U/L U&L',
                                                    name: 'LowerClearRetainerDesignLower',
                                                    label: 'Lower Arch Retention',
                                                    value: false,
                                                    children: {
                                                        component: 'RadioRhf',
                                                        name: 'LowerClearRetainerDesignLowerOption',
                                                        option: archRententionOption,
                                                    },
                                                },
                                            }}
                                            // question={getDiffRetainerLang(`formQuestionLabel.${questions['5A'].name}`)}
                                            question={retainerDesignQuestion}
                                            control={control}
                                            errors={errors}
                                            row={false}
                                            formValues={formValues}
                                            impressionType={impressionType}
                                            subType={type}
                                            disable={!enableClearRetainerDesignQuestion}
                                        />
                                    </div>
                                </div>
                            </li>
                        )}

                        {/* {enableClearRetainerDesignQuestionForSecondSetRetainer && (
                            <li>
                                <div style={{marginTop : 24}}>
                                    <div style={{ color: enableClearRetainerDesignQuestionForSecondSetRetainer ? 'black' : 'gray' }}>
                                        <ClearRetainerRhf
                                                questionData={{
                                                    A : {
                                                        question: "6. Clear Retainer Design Question U/L/U&L for the second set of Ecodont Retainers with wire",
                                                        name:'UpperClearRetainerDesignUpperForSecondSet',
                                                        label:'Upper Arch Retention',
                                                        value:false,
                                                        children:{
                                                            component:'RadioRhf',
                                                            name:"UpperClearRetainerDesignUpperOptionForSecondSet",
                                                            option:archRententionOption
                                                        }
                                                    },
                                                    B : {
                                                        question: "6. Clear Retainer Design Question U/L/U&L for the second set of Ecodont Retainers with wire",
                                                        name:'LowerClearRetainerDesignLowerForSecondSet',
                                                        label:'Lower Arch Retention',
                                                        value:false,
                                                        children:{
                                                            component:'RadioRhf',
                                                            name:'LowerClearRetainerDesignLowerOptionForSecondSet',
                                                            option:archRententionOption
                                                        }
                                                    }
                                                }}
                                                question={getDiffRetainerLang(`formQuestionLabel.${questions['6A'].name}`)} 
                                                control={control}
                                                errors={errors}
                                                row={false}
                                                formValues={formValues}
                                                impressionType={impressionType}
                                                subType={type}
                                                disable={!enableClearRetainerDesignQuestionForSecondSetRetainer} 
                                            />
                                    </div>
                                </div>
                            </li>
                        )} */}

                        <div style={{ marginTop: 24, marginBottom: 24 }}>
                            {/* <li>
                                <div>
                                    <TeethEquipmentRhf
                                        option={questions[7].option}
                                        question={questions[7].question}
                                        name={fieldName[7]}
                                        control={control}
                                        errors={errors}
                                        defaultValue="false"
                                        row={false}
                                        teethSelectionDisabled={formValues[`${type}Pontics`] === 'false'}
                                        selectedTooth={toothForPontics}
                                        setSelectedTooth={setToothForPontics}
                                    />
                                </div>
                            </li> */}

                            {enablePontic && (
                                <>
                                    <li>
                                        <RadioRhf
                                            question={getDiffRetainerLang(
                                                `formQuestionLabel.${questions['pontic']?.name}_v2`
                                            )}
                                            errors={errors}
                                            name={`${type}Pontic`}
                                            control={control}
                                            row={false}
                                            // defaultValue={questions['pontic'].defaultValue}
                                            formControlLabelRhf={memoPonticOption.map((v, _) => (
                                                <RadioOptionRhf value={v.value} label={v.label} />
                                            ))}
                                        />
                                    </li>

                                    {formValues[`${type}Pontic`] === 'colourPonticRequired' && (
                                        <li>
                                            <SelectRhf
                                                control={control}
                                                // defaultValue={questions['ponticColor'].defaultValue}
                                                option={questions['ponticColor'].option}
                                                name={`${type}PonticColor`}
                                                label={getDiffRetainerLang(
                                                    `formQuestionLabel.${questions['ponticColor']?.name}_v2`
                                                )}
                                                errors={errors}
                                            />
                                        </li>
                                    )}
                                </>
                            )}
                        </div>
                    </ol>
                </section>
            </AccordionDetails>
        </Accordion>
    );
};

export default SingleTypePrescriptionNote;
